var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 50,
    rx: 24.5,
    fill: "#12B897"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 13.25C32.7109 13.25 39 18.3906 39 24.625C39 30.9141 32.7109 36 25 36C22.8672 36 20.8984 35.6172 19.0938 34.9609C17.7812 36.0547 15.0469 37.75 11.4375 37.75C11.2188 37.75 11.1094 37.6953 11 37.5312C10.9453 37.3672 11 37.1484 11.1094 37.0391C11.1094 36.9844 13.4062 34.5781 14.1172 31.7891C12.1484 29.8203 11 27.3594 11 24.625C11 18.3906 17.2344 13.25 25 13.25ZM31.125 25.0625V24.1875C31.125 23.75 30.6875 23.3125 30.25 23.3125H26.3125V19.375C26.3125 18.9375 25.875 18.5 25.4375 18.5H24.5625C24.0703 18.5 23.6875 18.9375 23.6875 19.375V23.3125H19.75C19.2578 23.3125 18.875 23.75 18.875 24.1875V25.0625C18.875 25.5547 19.2578 25.9375 19.75 25.9375H23.6875V29.875C23.6875 30.3672 24.0703 30.75 24.5625 30.75H25.4375C25.875 30.75 26.3125 30.3672 26.3125 29.875V25.9375H30.25C30.6875 25.9375 31.125 25.5547 31.125 25.0625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddComment);
export default __webpack_public_path__ + "static/media/icon_add_comment.d26df2bf5e00b32cded56b6aa5ed27e5.svg";
export { ForwardRef as ReactComponent };